import useResource from "./useResource"

export default function useDealComparableTopicRecordsView({ dealId, topicId }) {
  const key = `deals/${dealId}/comparables/topics/${topicId}/records/view`
  return useResource({ key })
}
